import { API_BASE_URL } from "@/config";
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'AfisForm',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
                first_names: '',
                surname: '',
                id_number: '',
                phone_number: '',
                email_address: ''
            }
        };
    },
    emits: ['service_status_complete'],
    methods: {
        handle_submit() {
            if (!this.form.first_names || !this.form.surname || !this.form.id_number || !this.form.phone_number || !this.form.email_address) {
                this.showError('Error', 'All fields are required.');
                return;
            }
            const TOKEN = localStorage.getItem('token');
            const AFIS_CRIMINAL_CHECK_API = `${API_BASE_URL}/verify_api/instant_verify_api/afis_criminal_check/`;

            this.error = '';

            $.ajax({
                url: AFIS_CRIMINAL_CHECK_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    first_names: this.form.first_names,
                    surname: this.form.surname,
                    id_number: this.form.id_number,
                    phone_number: this.form.phone_number,
                    email_address: this.form.email_address
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'AFIS Check ran successfully', 3000);
                    this.$emit('service_status_complete');
                    this.form.first_names = '';
                    this.form.surname = '';
                    this.form.id_number = '';
                    this.form.phone_number = '';
                    this.form.email_address = '';
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    this.showError('Error', error_message);
                }
            });
        }
    }
};
